import SeoHead from "@/Component/Seo/SeoHead";
import Testimonials from "@/Component/Module/Testimonials";
import { serverFetchReviewsList } from "@/services/server";
import { getCountryFromContext } from "@/utils/getCountryFromRequest";
import { fetchPageSeo } from "@/utils/pageSeo";
import { getTestimonialReviewTabs } from "@/utils/reviewHelpers";

export default function TestimonialsPage({ seo, seoCountry, initialReviewsByModule }) {
  return (
    <>
      <SeoHead seo={seo} country={seoCountry} fallbackTitle="Testimonials | Next Holidays" />
      <Testimonials initialReviewsByModule={initialReviewsByModule} />
    </>
  );
}

export async function getServerSideProps(context) {
  const country = getCountryFromContext(context);
  const seoResult = await fetchPageSeo(context);
  if (seoResult.redirect) return seoResult;

  try {
    const isIndia = country === "IN";
    const reviewTabs = getTestimonialReviewTabs(isIndia);

    const responses = await Promise.all(
      reviewTabs.map((tab) =>
        serverFetchReviewsList({ moduleType: tab.id }, country)
      )
    );

    const initialReviewsByModule = reviewTabs.reduce(
      (acc, tab, index) => {
        acc[tab.id] = responses[index]?.data || null;
        return acc;
      },
      {}
    );

    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        initialReviewsByModule,
      },
    };
  } catch (error) {
    console.error("Testimonials page SSR error:", error);
    return {
      props: {
        seo: seoResult.seo,
        seoCountry: seoResult.seoCountry,
        initialReviewsByModule: {},
      },
    };
  }
}
